var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 19.3335H17.8333M19.1667 22.0002H17.8333M23.1667 16.6668H17.8333M25.8333 19.0002V16.5335C25.8333 15.4134 25.8333 14.8533 25.6154 14.4255C25.4236 14.0492 25.1176 13.7432 24.7413 13.5515C24.3135 13.3335 23.7534 13.3335 22.6333 13.3335H18.3667C17.2466 13.3335 16.6865 13.3335 16.2587 13.5515C15.8824 13.7432 15.5764 14.0492 15.3847 14.4255C15.1667 14.8533 15.1667 15.4134 15.1667 16.5335V23.4668C15.1667 24.5869 15.1667 25.147 15.3847 25.5748C15.5764 25.9511 15.8824 26.2571 16.2587 26.4488C16.6865 26.6668 17.2466 26.6668 18.3667 26.6668H20.1667M27.1667 26.6668L26.1667 25.6668M26.8333 24.0002C26.8333 25.2888 25.7887 26.3335 24.5 26.3335C23.2113 26.3335 22.1667 25.2888 22.1667 24.0002C22.1667 22.7115 23.2113 21.6668 24.5 21.6668C25.7887 21.6668 26.8333 22.7115 26.8333 24.0002Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDoc);
export default __webpack_public_path__ + "static/media/search-doc.6ff3da6192851c591ee2c114000d2df1.svg";
export { ForwardRef as ReactComponent };